<template>
    <div class="root" v-loading="loading">
        <div style="height: 100%; overflow: hidden;">
            <div style="background-color: #4a8cef; height: 50%; position: relative;">
                <div style="width: 420px; max-width: 80%; position: absolute; bottom: 0; left: 50%; transform: translate(-50%);">
                    <div style="color: #fff; text-align: center; margin-bottom: 40px;  font-size: 22px;">金园超市意见建议管理系统</div>
                    <div style="background-color: #5593f0; text-align: center;   box-shadow: 0px 0px 10px rgba(0,0,0,0.2);">
                        <div style="line-height: 60px; color: #fff; font-size: 18px;">Login</div>
                            <div style="width: 80%; margin: auto; padding-bottom: 1px;">
                                <el-input placeholder="账号" prefix-icon="el-icon-user" v-model="username" maxlength="100" @input="limitLength"></el-input>
                                <div style="margin: 20px 0;">
                                    <el-input placeholder="密码" prefix-icon="el-icon-lock" maxlength="20" show-password v-model="password"></el-input>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div style="background-color: #ffffff; height: 50%;  position: relative;">
                <div style="width: 420px; max-width: 80%; position: absolute; top: 0; left: 50%; transform: translate(-50%);  box-shadow: 0px 0px 10px rgba(0,0,0,0.2);">
                    <div style="">
                        <div style="width: 80%; margin: auto; padding-bottom: 1px;">
                            <div style="margin-top: 10px;">
                                <el-checkbox v-model="rememberChecked" >记住密码</el-checkbox>
                            </div>
                            <div style="margin: 20px 0;">
                                <el-button type="primary" style="width: 100%;" @click="submit">登录</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import sha1 from "sha1";
import router from '../../router';

export default {
    name: 'wenda',
    data: function () {
        return {
            radio: '1',
            list: [],
            password: '',
            username: '',
            rememberChecked:true,
            dialogVisible: false,
            loading:false
        }
    },
    components: {

    },
    methods: {
        changecheckbox(){
            var r = this.rememberChecked;
            console.log(r);
            console.log(!r);
            this.rememberChecked=!r;
            console.log(this.rememberChecked);
        },
        limitLength() {
            if (this.username.length > 100) {
                this.username = this.username.slice(0, 100)
            }
        },

        submit: function () {
            console.log(this.username, this.password)
            if(this.username==null || this.username==undefined || this.username==''){
                this.$message.error('请输入账号');
                return;
            } 
            // else {
            //     var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
            //     if (this.username === '' || !reg.test(this.username)) {
            //     this.$message.error('The email address is not valid.');
            //     return;
            //     }
            // }
            if(this.password==null || this.password==undefined ||this.password==''){
                this.$message.error('请输入密码');
                return;
            }

            this.login();
        },
        login() {
            this.loading=true;
            var passwordhash = sha1('szdxx18133759633'+this.password);
            axios.post('/api/Login/Post',
                {
                    username: this.username,
                    passwordhash: this.password
                }
            )
                .then(this.getHomeInfoSucc)
        },
        getHomeInfoSucc(res) {
            res = res.data
            console.log(res);
            this.loading=false;
            if (res && res.Code == 200) {
                if(this.rememberChecked){
                    localStorage.setItem("rememberChecked",1);
                    localStorage.setItem("username",this.username);
                    localStorage.setItem("password",this.password);
                }else{
                    localStorage.removeItem("username");
                    localStorage.removeItem("password");
                    localStorage.removeItem("rememberChecked");
                }
                var userJson = {
                    uid:res.uid,
                    token:res.token,
                    nickname:res.nickname,
                    permissions:res.permissions
                }
                localStorage.setItem('userJson', JSON.stringify(userJson));
                
                this.$message({
                    message: '登录成功！',
                    type: 'success',
                    duration:2000,
                    onClose: function () {
                        router.replace('/badgelist')
                    }
                });

            }else{
                //if(res.Code==304 || res.Code==305)
                {
                this.$message.error("登录失败");
                }
            }
        },


    },
    mounted() {
         console.log("mounted");
         var rememberChecked = localStorage.getItem("rememberChecked");
         var username = localStorage.getItem("username");
         var password = localStorage.getItem("password");
         this.username=username;
         this.password=password;
         this.rememberChecked = Boolean(rememberChecked);
    }
}
</script>

<style> 
.el-message{
max-width: 90% !important;
}
</style>

<style scoped>
.root {
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
}

.header {
    padding: .24rem;
    display: flex;
}

.headertxt {
    flex: 1;
    text-align: center;
    color: #fff;
    margin-right: 20px;
    line-height: 20px;
}

.back-icon {
    font-size: .4rem;
    color: #fff;
}

.questiondiv {
    /* height: calc(100vh - 20vh - 44px); */
    overflow-y: scroll;
    background: #fff;
    width: 90vw;
    margin: 10vh auto 20px auto;
    padding: 12px;
    border-radius: 5px;
    box-sizing: border-box;
}

.questiontitle {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
}

.option {
    font-size: 18px;
    margin-bottom: 10px;
    border: 1px #f1f1f1 solid;
    padding: 10px;
    line-height: 22px;
}

.option.selected {
    border-color: #BA0109;
    color: #BA0109;
    text-decoration: line-through;
}

.option.selected2 {

    border-color: green;
    color: green;

}

.mybtns {
    width: 80vw;
    display: flex;
    margin: 20px auto;
}

.btnpre {
    flex: 1;
    margin-right: 10px;
    color: #e6a23c;
    text-align: center;
    padding: 10px;
    border-radius: 1000px;
    border: 1px solid #e6a23c;
}

.btnnext {
    flex: 1;
    margin-left: 10px;
    color: #fff;
    text-align: center;
    padding: 10px;
    border-radius: 1000px;
    background: #e6a23c;
}

.btnsubmit {
    flex: 1;
    margin-left: 10px;
    color: #fff;
    text-align: center;
    padding: 10px;
    border-radius: 1000px;
    background: #67c23a;
}

.errmsg {
    color: red;
    margin: 5px auto 10px auto;
}

.inputitem {
    display: flex;
    border: 1px #eee solid;
    border-bottom: none;
}

.inputlabel span {
    color: red;
}

.inputlabel {
    margin: 10px;
    line-height: 21px;
}

.inputdiv {
    margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue